module.exports = __webpack_public_path__ + "fonts/webzuliapack.1cb8daf9.eot";